module.exports = __webpack_public_path__ + "img/D1AC04_F8E50A_EDD004_B38D04-256px.0b2a3e96.png";